export const beforeItems = [
  'Godzinami planujesz każdy trening od zera',
  'Szukasz przypadkowych ćwiczeń w internecie, bez progresji',
  'Nie masz pewności, czy uczysz we właściwej kolejności',
  'Czujesz się niepewnie przy korygowaniu techniki',
  'Nie masz jak zmierzyć postępów zawodników',
]

export const afterItems = [
  'Kompletny plan gotowy na cały rok',
  'Gotowe sesje z ćwiczeniami i diagramami boiska',
  'Jasna progresja poziom po poziomie, od podstaw do zaawansowanych',
  'Punkty nauczania i najczęstsze błędy wyjaśnione krok po kroku',
  'Testy i listy kontrolne do pomiaru postępów',
]

export const transformationStats = [
  { value: '360+', label: 'STRON TREŚCI' },
  { value: '6', label: 'PROGRESYWNYCH POZIOMÓW' },
  { value: '100%', label: 'DO ZASTOSOWANIA' },
]
